module.exports = __webpack_public_path__ + "media/Video 64.7c83bd21.mp4";